import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import AmountItem from './AmountItem';
import { messages } from './messages';
import {
  calculatePercentWidthForAvg,
  calculatePercentWidthForNationalAvg,
} from '../../../utils/scholarships';

export default function AverageGrantAmount({ costsData, tuitionStatistics }) {
  const grantValue = get(costsData, 'averageAmountOfAid.grant.value', 0);
  const grantAverageValue = get(
    tuitionStatistics,
    'FOUR_YEAR.AVERAGES.grantAidAmount',
    0,
  );
  const grantWidth = calculatePercentWidthForAvg(
    costsData,
    tuitionStatistics,
    'grant',
    'grantAidAmount',
  );
  const averageWidth = calculatePercentWidthForNationalAvg(
    tuitionStatistics,
    'grantAidAmount',
  );

  return (
    <AmountItem
      value={grantValue}
      legend={messages.avgGrantAmount}
      width={grantWidth}
      averageWidth={averageWidth}
      averageValue={grantAverageValue}
      information={messages.grantInformation}
      description={messages.grantDescription}
    />
  );
}

AverageGrantAmount.propTypes = {
  costsData: PropTypes.object,
  tuitionStatistics: PropTypes.object,
};
